const DOCUMENT = 'TALENT_';
const AVAILABILITIES = DOCUMENT + 'AVAILABILITIES_';

const actions = {
  ADD_SKILL_EDIT_PAGE: DOCUMENT + 'ADD_SKILL_EDIT_PAGE',
  CANCEL: DOCUMENT + 'CANCEL',
  CHANGE_LEVEL: DOCUMENT + 'CHANGE_LEVEL',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CHANGE_SKILL: DOCUMENT + 'CHANGE_SKILL',
  CHANGE_STATE: DOCUMENT + 'CHANGE_STATE',
  CHANGE_STATUS: DOCUMENT + 'CHANGE_STATUS',
  CHANGE_TAX_INFORMATION: DOCUMENT + 'CHANGE_TAX_INFORMATION',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  DELETE: DOCUMENT + 'DELETE',
  DELETE_SKILL: DOCUMENT + 'DELETE_SKILL',
  DELETE_SUCCESS: DOCUMENT + 'DELETE_SUCCESS',
  EDIT: DOCUMENT + 'EDIT',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_AVAILABILITIES: AVAILABILITIES + 'LOAD',
  LOAD_AVAILABILITIES_SUCCESS: AVAILABILITIES + 'LOAD_SUCCESS',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',
  TOGGLE_SUSPENSION_MODAL: DOCUMENT + 'TOGGLE_SUSPENSION_MODAL',
  TOGGLE_TERMINATION_MODAL: DOCUMENT + 'TOGGLE_TERMINATION_MODAL',
  TOUCH: DOCUMENT + 'TOUCH',
  UPDATE: DOCUMENT + 'UPDATE',
  RESEND_CONTRACTS_REQUEST: DOCUMENT + 'RESEND_CONTRACTS_REQUEST',
  RESEND_CONTRACTS_SUCCESS: DOCUMENT + 'RESEND_CONTRACTS_SUCCESS',
  RESEND_CONTRACTS_ERROR: DOCUMENT + 'RESEND_CONTRACTS_ERROR',

  loadData: payload => ({
    type: actions.LOAD,
    payload,
  }),

  loadAvailabilitiesData: payload => ({
    payload,
    type: actions.LOAD_AVAILABILITIES,
  }),

  loadAvailabilitiesDataSuccess: payload => {
    return {
      payload,
      type: actions.LOAD_AVAILABILITIES_SUCCESS,
    };
  },

  changeStatus: payload => ({
    type: actions.CHANGE_STATUS,
    payload,
  }),

  loadDataSuccess: payload => ({
    type: actions.LOAD_SUCCESS,
    payload,
  }),

  update: payload => ({
    type: actions.UPDATE,
    payload,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  edit: payload => ({
    type: actions.EDIT,
    payload,
  }),

  save: payload => ({
    type: actions.SAVE,
    payload,
  }),

  changeState: payload => ({
    type: actions.CHANGE_STATE,
    payload,
  }),

  saveSuccess: payload => ({
    type: actions.SAVE_SUCCESS,
    payload,
  }),

  saveError: payload => ({
    type: actions.SAVE_ERROR,
    payload,
  }),

  delete: payload => ({
    type: actions.DELETE,
    payload,
  }),

  deleteSuccess: () => ({
    type: actions.DELETE_SUCCESS,
  }),

  changeProperty: payload => ({
    type: actions.CHANGE_PROPERTY,
    payload,
  }),

  changeSkill: payload => ({
    type: actions.CHANGE_SKILL,
    payload,
  }),

  changeLevel: payload => ({
    type: actions.CHANGE_LEVEL,
    payload,
  }),

  changeTaxInformation: payload => ({
    type: actions.CHANGE_TAX_INFORMATION,
    payload,
  }),

  changeProperties: payload => ({
    type: actions.CHANGE_PROPERTIES,
    payload,
  }),

  cancel: () => ({
    type: actions.CANCEL,
  }),

  touch: payload => ({
    type: actions.TOUCH,
    payload,
  }),

  loadFormData: payload => ({
    type: actions.LOAD_FORM_DATA,
    payload,
  }),

  deleteSkill: payload => ({
    type: actions.DELETE_SKILL,
    payload,
  }),

  addSkillOnEditPage: payload => ({
    type: actions.ADD_SKILL_EDIT_PAGE,
    payload,
  }),

  sendRequest: payload => ({
    type: actions.SEND_REQUEST,
    payload,
  }),

  toggleTerminationModal: (payload = {}) => ({
    type: actions.TOGGLE_TERMINATION_MODAL,
    payload,
  }),

  toggleSuspensionModal: (payload = {}) => ({
    type: actions.TOGGLE_SUSPENSION_MODAL,
    payload,
  }),

  resendContractsRequest: payload => ({
    type: actions.RESEND_CONTRACTS_REQUEST,
    payload,
  }),

  resendContractsSuccess: () => ({
    type: actions.RESEND_CONTRACTS_SUCCESS,
  }),

  resendContractsError: () => ({
    type: actions.RESEND_CONTRACTS_ERROR,
  }),
};

export default actions;
